export const footerStyles = {
  wrapper: {
    backgroundColor: 'var(--mantine-color-brand-9)',
    color: 'var(--mantine-color-gray-0)',
    marginTop: 'var(--mantine-spacing-xl)',
  },

  logoGroup: {
    marginBottom: 'var(--mantine-spacing-xs)',
  },

  logo: {
    color: 'var(--mantine-color-gray-0)',
    transition: 'color 0.2s ease',
    
    '&:hover': {
      color: 'var(--mantine-color-blue-4)',
    },
  },

  description: {
    lineHeight: 1.6,
    color: 'var(--mantine-color-gray-4)',
  },

  socialLinks: {
    marginTop: 'var(--mantine-spacing-sm)',
  },

  socialButton: {
    transition: 'all 0.2s ease',
    
    '&:hover': {
      backgroundColor: 'var(--mantine-color-gray-7)',
      transform: 'translateY(-2px)',
    },
  },

  sectionTitle: {
    color: 'var(--mantine-color-gray-0)',
    marginBottom: 'var(--mantine-spacing-xs)',
    position: 'relative',
    
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: -4,
      left: 0,
      width: 30,
      height: 2,
      backgroundColor: 'var(--mantine-color-blue-6)',
    },
  },

  link: {
    transition: 'all 0.2s ease',
    textDecoration: 'none',
    
    '&:hover': {
      color: 'var(--mantine-color-blue-4)',
      textDecoration: 'underline',
    },
  },

  contactItem: {
    alignItems: 'flex-start',
    border: '2px solid var(--mantine-color-white)',
    outline: '5px solid var(--mantine-color-white)',
    outlineOffset: '2px',
    borderRadius: 'var(--mantine-radius-md)',
   // padding: 'var(--mantine-spacing-md)',
    marginTop: 'var(--mantine-spacing-md)',
    marginBottom: 'var(--mantine-spacing-md)',
   // maxWidth: '600px',
    width: '100%',
  },

  divider: {
    borderColor: 'var(--mantine-color-gray-6)',
  },

  bottomBar: {
    alignItems: 'center',
  },

  copyright: {
    color: 'var(--mantine-color-gray-5)',
  },

  legalLink: {
    transition: 'color 0.2s ease',
    
    '&:hover': {
      color: 'var(--mantine-color-blue-4)',
    },
  },
}